export default "__VITE_ASSET__7794b23f__"